export default __webpack_public_path__ + "pgnv-assets/c41ea72351a52b357f1e795d551e1c0b.png";